module.exports = __webpack_public_path__ + "static/media/logo.502a80b9.png";